module.exports = "/fonts/vendor/typeface-open-sans/files/open-sans-latin-800italic.woff?3d3bd0835c258f5bd0bce57bb1963a9c";